var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.saveDrug.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("Priority", { attrs: { drug: _vm.drug } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group mt-1" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Название на платформе"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drug.title,
                          expression: "drug.title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "text" },
                      domProps: { value: _vm.drug.title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.drug, "title", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Название на английском"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drug.en_title,
                          expression: "drug.en_title",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.drug.en_title },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.drug, "en_title", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Предложенное ЧПУ"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drug.slug,
                          expression: "drug.slug",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.drug.slug },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.drug, "slug", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("Recipe", {
                        attrs: { detail: _vm.details.recipe[0] },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.details.egk
                        ? [
                            _c("EgkSelect", {
                              ref: "egkCodes",
                              attrs: {
                                details: _vm.details.egk,
                                updateDetail: (d) => (this.details.egk = d),
                              },
                            }),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.drug.income_country_id,
                            expression: "drug.income_country_id",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.drug,
                                "income_country_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            _vm.updateCostPrice,
                          ],
                        },
                      },
                      _vm._l(_vm.$AllCountries, function (country) {
                        return _c(
                          "option",
                          { domProps: { value: country.id } },
                          [
                            _vm._v(
                              _vm._s(country.name) +
                                " /\n                    " +
                                _vm._s(
                                  _vm.$AllCurrencies[country.currency_id]
                                    .currency
                                ) +
                                "\n                  "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.buyPrice,
                          expression: "buyPrice",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        required: "",
                        type: "text",
                        placeholder: "Закупка",
                      },
                      domProps: { value: _vm.buyPrice },
                      on: {
                        change: _vm.updateCostPrice,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.buyPrice = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-prepend" }, [
                      _c("span", { staticClass: "input-group-text" }, [
                        _c("strong", [_vm._v("€ " + _vm._s(_vm.costPrice))]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("Registration", {
                    attrs: {
                      drug: _vm.drug,
                      detail: _vm.details.registration[0],
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("p", [_vm._v("Дополнительная страна закупки")]),
                  _vm._v(" "),
                  _c("SupplyCountries", {
                    attrs: {
                      drug: _vm.drug,
                      details: _vm.details.extra.country,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("SelectCombineDrugs", {
                    ref: "combineDrugs",
                    attrs: { drugIsCombined: false },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Производитель"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.manufacturer[0].title.value,
                        expression: "details.manufacturer[0].title.value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: {
                      value: _vm.details.manufacturer[0].title.value,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.details.manufacturer[0].title,
                          "value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Страна производитель"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.manufacturer[0].country.value,
                        expression: "details.manufacturer[0].country.value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: {
                      value: _vm.details.manufacturer[0].country.value,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.details.manufacturer[0].country,
                          "value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Действующее вещество"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.substance,
                        expression: "drug.substance",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.drug.substance },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "substance", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Форма выпуска"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.release_form,
                        expression: "drug.release_form",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.drug.release_form },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "release_form", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Препарат (для текста АВД)"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.drug,
                        expression: "drug.drug",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.drug.drug },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "drug", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("В упаковке")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.in_set,
                        expression: "drug.in_set",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.drug.in_set },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "in_set", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Рецептурность"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drug.site_prescription,
                          expression: "drug.site_prescription",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.drug,
                            "site_prescription",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "1" } }, [
                        _vm._v("По рецепту"),
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "2" } }, [
                        _vm._v("Без рецепта"),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Код PZN")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.manufacturer[0].pzn.value,
                        expression: "details.manufacturer[0].pzn.value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.details.manufacturer[0].pzn.value },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.details.manufacturer[0].pzn,
                          "value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "" } }, [_vm._v("Фасовка")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.packaging,
                        expression: "drug.packaging",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: { value: _vm.drug.packaging },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "packaging", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v("комплектность:"),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.drug.pack_set,
                          expression: "drug.pack_set",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { required: "", type: "number" },
                      domProps: { value: _vm.drug.pack_set },
                      on: {
                        change: _vm.updateCostPrice,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.drug, "pack_set", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group mt-1" }, [
                  _c("label", { attrs: { for: "" } }, [_vm._v("Рубрика")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.category,
                          expression: "category",
                        },
                      ],
                      staticClass: "form-control",
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.category = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "0", disable: "" } }, [
                        _vm._v("Укажите рубрику"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.categories, function (cat) {
                        return _c("option", { domProps: { value: cat.id } }, [
                          _vm._v(_vm._s(cat.name)),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "ch11" } }, [
                  _vm._v("Регулярный прием (кол. дней)"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("div", { staticClass: "input-group-text" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.details.regular_reception[0].use.value,
                            expression:
                              "details.regular_reception[0].use.value",
                          },
                        ],
                        attrs: { id: "ch11", type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.details.regular_reception[0].use.value
                          )
                            ? _vm._i(
                                _vm.details.regular_reception[0].use.value,
                                null
                              ) > -1
                            : _vm.details.regular_reception[0].use.value,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.details.regular_reception[0].use.value,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.details.regular_reception[0].use,
                                    "value",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.details.regular_reception[0].use,
                                    "value",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.details.regular_reception[0].use,
                                "value",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.details.regular_reception[0].days.value,
                        expression: "details.regular_reception[0].days.value",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "number" },
                    domProps: {
                      value: _vm.details.regular_reception[0].days.value,
                    },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.details.regular_reception[0].days,
                          "value",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("Цены от количества"),
                    ]),
                    _vm._v(" "),
                    _c("DiffPrices", {
                      attrs: {
                        prices: _vm.prices,
                        singlePrice: true,
                        updateRecords: (r) => {
                          this.prices = r
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-check" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedNoSiteProjects[7].selected,
                          expression: "selectedNoSiteProjects[7].selected",
                        },
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox", id: "ch__1" },
                      domProps: {
                        checked: Array.isArray(
                          _vm.selectedNoSiteProjects[7].selected
                        )
                          ? _vm._i(
                              _vm.selectedNoSiteProjects[7].selected,
                              null
                            ) > -1
                          : _vm.selectedNoSiteProjects[7].selected,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.selectedNoSiteProjects[7].selected,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.selectedNoSiteProjects[7],
                                  "selected",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.selectedNoSiteProjects[7],
                                  "selected",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.selectedNoSiteProjects[7],
                              "selected",
                              $$c
                            )
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "ch__1" },
                      },
                      [_vm._v("Создать на АнУ")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.selectedNoSiteProjects[7].selected
                    ? _c(
                        "div",
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Цены на проекте"),
                          ]),
                          _vm._v(" "),
                          _c("DiffPrices", {
                            attrs: {
                              prices: _vm.selectedNoSiteProjects[7].prices,
                              updateRecords: (r) => {
                                this.selectedNoSiteProjects[7].prices = r
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("p", [
              _vm._v("Укажите сайты на которых необходимо создать препарат"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-group btn-group-toggle flex mb-2",
                attrs: { "data-toggle": "buttons" },
              },
              [
                _vm._l(_vm.selectedProjects, function (project) {
                  return [
                    _c(
                      "label",
                      {
                        class: {
                          "btn btn-outline-success mr-1": true,
                          active: project.selected,
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: project.selected,
                              expression: "project.selected",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(project.selected)
                              ? _vm._i(project.selected, null) > -1
                              : project.selected,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = project.selected,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        project,
                                        "selected",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        project,
                                        "selected",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(project, "selected", $$c)
                                }
                              },
                              () => _vm.updateSelectedProjects(project.id),
                            ],
                          },
                        }),
                        _vm._v(
                          "\n                " +
                            _vm._s(project.title) +
                            "\n              "
                        ),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Ключевые слова ( разделитель - запятая )"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.keywords,
                        expression: "drug.keywords",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { rows: "2" },
                    domProps: { value: _vm.drug.keywords },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "keywords", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Комментарии по упаковке"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.pack_box_comment,
                        expression: "drug.pack_box_comment",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { rows: "2" },
                    domProps: { value: _vm.drug.pack_box_comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.drug,
                          "pack_box_comment",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "" } }, [
                    _vm._v("Главный ключевик (разделитель - запятая)"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.main_keywords,
                        expression: "drug.main_keywords",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { rows: "2" },
                    domProps: { value: _vm.drug.main_keywords },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "main_keywords", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Создать препарат",
                    className: "btn btn-success",
                    type: "submit",
                    onClick: () => {},
                    loading: _vm.btnLoading,
                    color: "white",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }